import stats from "./stats.component";
import statsUrls from "./stats.urls";
import StatsTransforms from "./stats.transforms";

const statsModule = angular
  .module("app.components.stats", [])
  .component("statsPage", stats)
  .service("StatsTransforms", StatsTransforms)
  .config(statsUrls);

export default statsModule;



// WEBPACK FOOTER //
// ./src/pages/stats/stats.module.js